"use client";
import "../../../chunk-MMUBH76A.js";
const getActions = (set, get) => ({
  updateState: (state) => {
    set(state);
  },
  getLogo: () => {
    var _a;
    return (_a = get().logo) != null ? _a : void 0;
  },
  setAuthLayout: (authLayout) => {
    const types = [];
    const uniqueLayouts = [];
    authLayout.map((layout) => {
      const type = layout.split(":")[0];
      if (!types.includes(type)) {
        uniqueLayouts.push(layout);
        types.push(type);
      } else {
        console.warn(`${layout} is a duplicate ${type} layout type. Please remove the duplicate type from your config.`);
      }
    });
    set({ authLayout: uniqueLayouts });
  }
});
export {
  getActions
};
